import styled, { css, keyframes } from 'styled-components'

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

export const SliderContainer = styled.div`
  margin: auto;
  width: 100%;
  height: 100%;
  padding-block: 2rem;
  background: white;
  align-content: center;
  .swiper-wrapper {
    margin-inline-start: 1.2rem;
  }
`
export const Subtitle = styled.p`
  color: #030852;
  text-align: center;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: bold;

  &::before,
  &::after {
    content: '-';
    margin: 0 1rem;
    color: #030852;
  }

  @media screen and (max-width: 1024px) {
    font-size: 20px;
    font-weight: bold;
  }
  @media screen and (max-width: 650px) {
    font-size: 14px;
    font-weight: bold;
  }
`
export const RowSlider = styled.div<{ paused: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  animation: ${scroll} 10s linear infinite;
  animation-play-state: ${({ paused }) => (paused ? 'paused' : 'running')};
  gap: 1.3rem;
`

export const SwiperSlide = styled.div`
  display: flex;
`

export const Title = styled.h2`
  font-size: 4rem;
  text-align: center;
  color: #030852;
  margin-bottom: 3rem;
  animation: fadeInUp;
  animation-duration: 10s;
  span {
    color: #f7931e;
  }
  @media screen and (max-width: 1024px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
  @media screen and (max-width: 650px) {
    font-size: 1.5rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1.3rem;
  }
`

export const Card = styled.div<{ image: string }>`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  border-radius: 3.125rem;
  width: 300px;
  height: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1.5rem;
  color: white;
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(0deg, rgba(3, 8, 82, 1) 0%, rgba(255, 255, 255, 0) 100%);
    z-index: 0;
    border-bottom-left-radius: 3.125rem;
    border-bottom-right-radius: 3.125rem;
    border-radius: 3.125rem;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  h3 {
    font-size: 1.1rem;
    margin-bottom: 1rem;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent 60%);
    z-index: 0;
  }

  button {
    z-index: 1;
  }

  @media screen and (max-width: 770px) {
    width: 300px;
  }

  @media screen and (max-width: 450px) {
    width: 100%;
  }
`
